import { GeneratedSuggestions, GeneratedSuggestionsDTO } from '../../../@types/generate-suggestion-types'

export const mapFromDtoToGeneratedSuggestions = (suggestions: GeneratedSuggestionsDTO): GeneratedSuggestions => ({
  title: suggestions.headline,
  description: suggestions.propertyText,
  location: suggestions.areaText,
})
